<div #scrollWrapper class="table-responsive" [class.overflow-hidden]="emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover table footable">
        <thead>
        <tr [ngClass]="{'noSort': announcementsList.length < 2}">
            <ng-container *ngFor="let tableCol of tableColumns">
                <th *ngIf="tableCol.isVisible" (click)="orderBy(tableCol.sortable ? tableCol.key : null, $event)" [ngClass]="{'sortable': tableCol.sortable}">
                    {{tableCol.title}} <span *ngIf="tableCol.sortable" class="footable-sort-indicator"></span>
                </th>
            </ng-container>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let notice of announcementsList; let i = index" [ngClass]="{'footable-odd': (i % 2 === 0)}">
            <ng-container *ngFor="let tableCol of tableColumns">
                <td *ngIf="tableCol.isVisible" [ngSwitch]="tableCol.key" [ngClass]="tableCol.key">
                    <div class="table-mobile-left">
                        <span>{{tableCol.title}}</span>
                    </div>

                    <!-- Default cell -->
                    <ng-template ngSwitchDefault>
                        <span>{{notice[tableCol.key]}}</span>
                    </ng-template>

                    <!-- Subject output -->
                    <ng-template ngSwitchCase="title">
                        <span class="clickable-text mtv-primary-color" (click)="viewNotice(notice.id)">{{notice[tableCol.key]}}</span>
                    </ng-template>

                    <!-- Dates output -->
                    <ng-template [ngSwitchCase]="['createdAt', 'periodBegin', 'periodEnd'].includes(tableCol.key) ? tableCol.key : ''">
                        <span>{{notice[tableCol.key] | mccDate}}</span>
                    </ng-template>

                    <!-- Created by -->
                    <ng-template ngSwitchCase="createdBy">
                        <span>{{notice.createdBy.fullName}}</span>
                    </ng-template>

                    <!-- Status label -->
                    <ng-template ngSwitchCase="status">
                        <span class="text-uppercase label" [ngClass]="notice.status">{{notice.status}}</span>
                    </ng-template>

                    <!-- Action -->
                    <ng-template ngSwitchCase="action">
                        <div class="input-group-btn btn-in-table input-group" (click)="$event.showDropdown = true;">
                            <button (click)="viewNotice(notice.id)" class="btn btn-white btn-xs same-button-width">
                                View
                            </button>
                            <button *ngIf="isActionAllowed(notice.corporationNumberId, permission.create)" data-toggle="dropdown" class="btn btn-white dropdown-toggle btn-xs" aria-expanded="false">
                                <span class="caret"></span>
                            </button>
                            <ul class="dropdown-menu pull-right">
                                <li>
                                    <a *ngIf="isActionAllowed(notice.corporationNumberId, permission.update)" routerLink="/announcements/edit/{{notice.id}}">Edit</a>
                                    <a *ngIf="isActionAllowed(notice.corporationNumberId, permission.delete)" (click)="removeNotice(notice.id)">Delete</a>
                                </li>
                            </ul>
                        </div>
                    </ng-template>
                </td>
            </ng-container>
        </tr>
        <tr *ngFor="let item of rules.hasEnabledWebsites ? emptyRowService.emptyRow : []" class="empty-row" style="cursor: default;">
            <ng-container *ngFor="let tableCol of tableColumns">
                <td *ngIf="tableCol.isVisible">&nbsp;</td>
            </ng-container>
        </tr>
        </tbody>
    </table>

    <empty-result-message [isEmpty]="announcementsList && !announcementsList.length" [isServiceUnavailable]="isServiceUnavailable"
                          [isLoading]="spinnerShow">
        <div *ngIf="rules.hasEnabledWebsites">
            You have no announcements listed on the system<br>
            <span *ngIf="rules.canCreate">
                <a href="javascript://" (click)="onCreateItem.next()" class="mtv-primary-color clickable-text">add a new announcement</a> now
            </span>
        </div>
        <div *ngIf="!rules.hasEnabledWebsites">Announcements section is disabled because your public website is not published.<br><a routerLink="/website_builder">Click here</a> to start building your public website</div>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/announcements/announcements-list/announcements-list.component.html